import { render, staticRenderFns } from "./HospBook.vue?vue&type=template&id=a3e87048"
import script from "./HospBook.vue?vue&type=script&lang=js"
export * from "./HospBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports